// Current company + memberships. Initialized from the bootstrap
// payload on mount; persists which company the user is viewing.

import { createStore } from "./store"

export const companyStore = createStore({
  current: null,
  memberships: [],
})

export function initCompanyStore(bootstrap) {
  companyStore.setState({
    current: bootstrap.current_company,
    memberships: bootstrap.memberships || [],
  })
}
